module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="sorting-panel-region"></div>\n</section>\n\n<section class="zmags-section wide">\n    <div class="content experience-thumbnails"></div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/TemplateContentCollectionView.tpl
// module id = 2895
// module chunks = 0